__turbopack_context__.v({
  "amountToPayGroup": "_5Gz_Ka_amountToPayGroup",
  "container": "_5Gz_Ka_container",
  "costCard": "_5Gz_Ka_costCard",
  "emphasizedRow": "_5Gz_Ka_emphasizedRow",
  "labelWithSubtext": "_5Gz_Ka_labelWithSubtext",
  "row": "_5Gz_Ka_row",
  "rowRightAlign": "_5Gz_Ka_rowRightAlign",
  "supportingText": "_5Gz_Ka_supportingText",
  "transferText": "_5Gz_Ka_transferText",
});
